import React, { Component } from "react";
import {Link} from "react-router-dom";
import {next} from "../images";
import axios from "axios";
import { FAQ_SHOW_ALL_URL } from "../constants/path";

class FAQ extends Component {
	constructor(props) {
		super(props);
		this.state = {
			lists: '',
			faqIds: props.faqIds || ''
		}
	}

	componentDidMount() {
		window.scrollTo(0,0);
		axios.get(FAQ_SHOW_ALL_URL)
			.then(resulte => {
				// return resulte.json();
				return resulte.data;
			}).then(data => {
				let lists = data.faq.map((items) => {
					return (
						<div className="row mb-2 pr-3" key={items.id}>
							<div className="col-6 pt-2 faq-border-left">
								<div className="row border-bottom-faq">
									<div className="col-10 text-right faq-text">
										<Link to={{pathname: items.questions[0].link, state: { question: items.questions[0].question, answer: items.questions[0].answer }}} title={items.questions[0].question}>
											{items.questions[0].question}
										</Link>
									</div>
									<div className="col-2 text-left">
										<Link to={{pathname: items.questions[0].link, state: { question: items.questions[0].question, answer: items.questions[0].answer }}} title={items.questions[0].question}>
											<img className="next" src={next} alt={items.questions[0].question} title={items.questions[0].question}/>
										</Link>
									</div>
									</div>
								<div className="row pt-2 border-bottom-faq">
									<div className="col-10 text-right faq-text">
										<Link to={{pathname: items.questions[1].link, state: { question: items.questions[1].question, answer: items.questions[1].answer }}} title={items.questions[1].question}>
											{items.questions[1].question}
										</Link>
									</div>
									<div className="col-2 text-left">
										<Link to={{pathname: items.questions[1].link, state: { question: items.questions[1].question, answer: items.questions[1].answer }}} title={items.questions[1].question}>
											<img className="next" src={next} alt={items.questions[1].question} title={items.questions[1].question}/>
										</Link>
									</div>
								</div>
							</div>
							<div className="col-6 pr-4 pt-2">
								<div className="row border-bottom-faq">
									<div className="col-10 text-right faq-text">
										<Link to={{pathname: items.questions[2].link, state: { question: items.questions[2].question, answer: items.questions[2].answer }}} title={items.questions[2].question}>
											{items.questions[2].question}
										</Link>
									</div>
									<div className="col-2 text-left">
										<Link to={{pathname: items.questions[2].link, state: { question: items.questions[2].question, answer: items.questions[2].answer }}} title={items.questions[2].question}>
											<img className="next" src={next} alt={items.questions[2].question} title={items.questions[2].question}/>
										</Link>	
									</div>
								</div>
								<div className="row pt-2 border-bottom-faq">
									<div className="col-10 text-right faq-text">
										<Link to={{pathname: items.questions[3].link, state: { question: items.questions[3].question, answer: items.questions[3].answer }}} title={items.questions[3].question}>
											{items.questions[3].question}
										</Link>
									</div>
									<div className="col-2 text-left">
										<Link to={{pathname: items.questions[3].link, state: { question: items.questions[3].question, answer: items.questions[3].answer }}} title={items.questions[3].question}>
											<img className="next" src={next} alt={items.questions[3].question} title={items.questions[3].question}/>
										</Link>	
									</div>
								</div>
							</div>
							

							<div className="col-6 pt-1 faq-border-left-6">
								<div className="row">
									<div className="col-10 text-right faq-text">
										<Link to={{pathname: items.questions[4].link, state: { question: items.questions[4].question, answer: items.questions[4].answer }}} title={items.questions[4].question}>
											{items.questions[4].question}
										</Link>
									</div>
									<div className="col-2 text-left">
										<Link to={{pathname: items.questions[4].link, state: { question: items.questions[4].question, answer: items.questions[4].answer }}} title={items.questions[4].question}>
											<img className="next" src={next} alt={items.questions[4].question} title={items.questions[4].question}/>
										</Link>	
									</div>
								</div>

							</div>
							<div className="col-6 pr-4 pt-1">
								<div className="row pt-0">
									<div className="col-10 text-right faq-text">
										<Link to={{pathname: items.questions[5].link, state: { question: items.questions[5].question, answer: items.questions[5].answer }}} title={items.questions[5].question}>
											{items.questions[5].question}
										</Link>
									</div>
									<div className="col-2 text-left">
										<Link to={{pathname: items.questions[5].link, state: { question: items.questions[5].question, answer: items.questions[5].answer }}} title={items.questions[5].question}>
											<img className="next" src={next} alt={items.questions[5].question} title={items.questions[5].question}/>
										</Link>
									</div>
								</div>
							</div>
						</div>
					);
				});
				this.setState({lists: lists});
		});
	}

	render() {
		const subPageStyle = (this.props.subPageStyle) ? "faq-container p-3" : null;
		const borderRight = (this.props.borderRight) ? {borderRight: "5px solid #2699fb"} : {};
		return (
			<div className={`container mt-3 direction-rtl text-center ${subPageStyle} faq-main-container`} style={borderRight}>
				<div className="row pb-0">
					<div className="col-6">
						<h2 className="text-right mb-0 font-weight-bold">{this.props.title}</h2>
					</div>
					<div className="col-6 mb-0 text-left">
						<h3>
							<Link to={ (this.props.title === 'پرسش های متداول') ? "/faq" : "/articles" } >نمایش همه</Link>
						</h3>
					</div>
				</div>
				{ (this.props.title === 'پرسش های متداول') ? this.state.lists : null }
			</div>
		);
	}
}

export default FAQ;